import { render, staticRenderFns } from "./ProductsSelectorAdvanced.vue?vue&type=template&id=c6a3bde8"
import script from "./ProductsSelectorAdvanced.vue?vue&type=script&lang=js"
export * from "./ProductsSelectorAdvanced.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports